const config = {
  apiUrl: import.meta.env.VITE_API_URL || "https://ads-api.sweatch.ai",
};

export default config;
